import { ReactElement, ReactNode } from 'react'
import { motion } from 'framer-motion'

interface ScrollRevealProps {
  children: ReactNode
  className?: string
  delay?: number
  /** Animation duration in seconds (default: 0.4) */
  duration?: number
  /** Enable blur-in effect alongside opacity */
  blur?: boolean
  /**
   * Trigger animation on mount instead of scroll-into-view.
   * Use for above-the-fold content that should animate immediately on navigation.
   * Default: false (scroll-triggered)
   */
  animateOnMount?: boolean
}

export function ScrollReveal({
  children,
  className,
  delay = 0,
  duration = 0.4,
  blur = false,
  animateOnMount = false,
}: ScrollRevealProps): ReactElement {
  const animationTarget = { opacity: 1, filter: 'blur(0px)' }

  return (
    <motion.div
      initial={{ opacity: 0, filter: blur ? 'blur(4px)' : 'blur(0px)' }}
      {...(animateOnMount
        ? { animate: animationTarget }
        : { whileInView: animationTarget, viewport: { once: true, margin: '-50px' } }
      )}
      transition={{ duration, delay, ease: 'easeOut' }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
